export const bigPlayButtonCss = `
    .video-js .vjs-controls-disabled .vjs-big-play-button {
        display: none !important
    }

    .vjs-paused.vjs-has-started.video-js .vjs-big-play-button,.video-js.vjs-ended .vjs-big-play-button, .video-js.vjs-paused .vjs-big-play-button {
        display: block
    }

    .video-js .vjs-load-progress div,.vjs-seeking .vjs-big-play-button,.vjs-waiting .vjs-big-play-button {
        display: none !important
    }

    .video-js.vjs-ended .vjs-big-play-button {
        display: block !important;
    }

    .video-js .vjs-big-play-button {
        /* Copied from "simple" vjs skin */
        background-color: rgba(255, 255, 255, 0.4);
        font-size: 5em;
        border-radius: 50%;
        height: 2em !important;
        line-height: 2em !important;
        margin-top: -1em !important;
        top: 50%;
        left: 50%;
        margin-left: -1em;
        margin-top: -1em;
        width: 2em;
        height: 2em;
        line-height: 2em;
        border: none;
        border-radius: 50%;
        font-size: 3.5em;
        background-color: rgba(0,0,0,.45);
        color: #fff;
        -webkit-transition: border-color .4s,outline .4s,background-color .4s;
        -moz-transition: border-color .4s,outline .4s,background-color .4s;
        -ms-transition: border-color .4s,outline .4s,background-color .4s;
        -o-transition: border-color .4s,outline .4s,background-color .4s;
        transition: border-color .4s,outline .4s,background-color .4s;

        &:focus, &:active {
            background-color: rgba(255, 255, 255, 0.7);
        }
    }

    .video-js:hover .vjs-big-play-button {
        background-color: rgba(255, 255, 255, 0.7);
    }
`;
